import { render, staticRenderFns } from "./NotificationDetailsForAdmin.vue?vue&type=template&id=4b1ccac2"
import script from "./NotificationDetailsForAdmin.vue?vue&type=script&lang=js"
export * from "./NotificationDetailsForAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports